import axios, { InternalAxiosRequestConfig } from 'axios';
import React from 'react';

import SnackbarWithLinks from 'components/SnackbarWithLinks/SnackbarWithLinks';
import { appConfig } from 'constants/appConfig';
import { REFRESH_TOKEN, TOKEN, USER_ID } from 'constants/localStorage';
import { enqueueSnackbar, SnackbarKey, SnackbarOrigin } from 'notistack';
import { LOGIN } from 'router/routes';

interface ISnackbarWithLinksProps {
  id: SnackbarKey;
  message: string | number | boolean | React.ReactElement | Iterable<React.ReactNode>;
  variant: 'error';
  persist: boolean;
  style: React.CSSProperties;
  anchorOrigin: SnackbarOrigin;
  hideIconVariant: boolean;
  iconVariant: Record<string, React.ReactNode>;
}

const axiosInstance = axios.create({
  baseURL: appConfig.baseUrl,
  withCredentials: false,
  headers: {
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
    'Access-Control-Allow-Headers': 'Content-Type',
    'Content-Type': 'application/json',
  },
});

axiosInstance.interceptors.request.use(async (config: InternalAxiosRequestConfig) => {
  const accessToken = localStorage.getItem(TOKEN);

  if (accessToken) {
    config.headers.Authorization = `Bearer ${accessToken}`;
  }

  return config;
});

axiosInstance.interceptors.response.use(
  res => res,
  res => {
    if (res?.response?.status === 401 && res?.config?.url !== '/Token') {
      localStorage.removeItem(TOKEN);
      localStorage.removeItem(REFRESH_TOKEN);
      localStorage.removeItem(USER_ID);

      window.location.replace(LOGIN);

      return;
    }

    const errorMessage = res?.response?.data?.message || 'An error occurred';

    enqueueSnackbar(errorMessage, {
      variant: 'error',
      autoHideDuration: 8000,
      content: (key, message) => {
        const props: ISnackbarWithLinksProps = {
          id: key,
          message: message ?? errorMessage,
          variant: 'error',
          persist: false,
          style: {},
          anchorOrigin: { vertical: 'bottom', horizontal: 'right' },
          hideIconVariant: false,
          iconVariant: {},
        };
        return React.createElement(SnackbarWithLinks, props);
      },
    });
  },
);

export default axiosInstance;
